<template lang="pug">
  el-row
    avue-crud(
      ref="crud",
      :data="data",
      :table-loading="loading",
      :option="option",
      :page.sync="page",
      @selection-change="selectionChange",
      @search-change="searchChange",
      @search-reset="searchReset",
      @current-change="currentChange",
      @size-change="sizeChange",
      @refresh-change="refreshChange",
      @on-load="onLoad"
    )
</template>
<script>
/**
 * 内容管理-协议管理-列表
 */
import { searchPushUserList } from '@/api/announce'
export default {
  name: 'PushUser',
  data() {
    return {
      form: {},
      selectionId: '',
      selectionList: [],
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        refreshBtn: false,
        indexLabel: '序号',
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        editBtnText: '更新',
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        selection: true,
        stripe: true,
        searchSpan: 9,
        reserveSelection: true,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menu: false,
        column: [
          {
            label: '头像',
            prop: 'avatar',
            type: 'img',
            overHidden: true
          },
          {
            label: '昵称',
            prop: 'nickname',
            width: 150,
            search: true,
            whiteSpace: true,
            overHidden: true
          },
          {
            label: '手机号',
            prop: 'mobile',
            search: true,
            all: true,
            span: 24,
            width: 150,
            overHidden: true
          },
          {
            label: '性别',
            prop: 'sex',
            search: true,
            type: 'select',
            dicData: [
              { label: '全部', value: null },
              { label: '男', value: 1 },
              { label: '女', value: 2 }
            ],
            all: true,
            span: 24,
            overHidden: true
          },
          {
            label: '年龄',
            prop: 'age',
            search: true,
            all: true,
            span: 24,
            overHidden: true
          },
          {
            label: '终端',
            prop: 'client',
            search: true,
            type: 'select',
            dicData: [
              { label: '全部', value: null },
              { label: 'IOS', value: 1 },
              { label: '安卓', value: 2 }
            ],
            all: true,
            span: 24,
            overHidden: true
          },
          {
            label: '省份',
            prop: 'provinceName',
            search: true,
            all: true,
            span: 24,
            overHidden: true
          },
          {
            label: '城市',
            prop: 'cityName',
            search: true,
            all: true,
            span: 24,
            overHidden: true
          }
        ]
      }
    }
  },
  mounted() {
    this.selectionClear()
  },
  methods: {
    selectionChange(list) {
      this.$emit('pushSelectonChange', list)
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      const { announceId } = this.$route.query
      const values = { ...params, announceId, frozenStatus: 0 }
      this.loading = true
      searchPushUserList(page.currentPage, page.pageSize, values)
        .then(res => {
          this.selectionList = []
          this.page.total = res.total
          this.data = res.data.map(item => {
            item.info.provinceName = item.info.province.provinceName
            item.info.cityName = item.info.city.cityName
            return item.info
          })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
